// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetApplicantsForPropertyWebApiResponseDto,
  GetLeaseSupportForPropertyWebApiResponseDto,
  GetPropertyInfoResponseDto,
  LeasingGetLeasesPaginatedResponseDto,
  ListingAlias,
  WebAnalyticsWebApiResponseDto,
} from '../..';

interface GetApplicantsForPropertyParams {
  propertyId: string;
}
interface GetLeaseSupportForPropertyParams {
  propertyId: string;
}
interface GetPaginatedLeasesForLandlordPropertyParams {
  listingAlias: ListingAlias;
  numResults: number;
  offset: number;
}
interface GetPropertyInfoParams {
  propertyId: string;
}
interface GetWebAnalyticsParams {
  listingAlias: ListingAlias;
}

export const LeasingPropertyWebApiHandler_getApplicantsForProperty_Path =
  '/api/web/v1/property/getApplicantsForProperty';

/**
 * get property applicants
 */
export const LeasingPropertyWebApiHandler_getApplicantsForProperty = (
  getParams: GetApplicantsForPropertyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetApplicantsForPropertyParams, never, GetApplicantsForPropertyWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyWebApiHandler_getApplicantsForProperty_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path =
  '/api/web/v1/property/getLeaseSupportForProperty';

/**
 * get the geography name and explainer lease for a property
 */
export const LeasingPropertyWebApiHandler_getLeaseSupportForProperty = (
  getParams: GetLeaseSupportForPropertyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseSupportForPropertyParams, never, GetLeaseSupportForPropertyWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyWebApiHandler_getLeaseSupportForProperty_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path =
  '/api/web/v1/property/getPaginatedLeasesForLandlordProperty';

/**
 * get all leases for property with message and signing by listing alias
 */
export const LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty = (
  getParams: GetPaginatedLeasesForLandlordPropertyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPaginatedLeasesForLandlordPropertyParams, never, LeasingGetLeasesPaginatedResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyWebApiHandler_getPaginatedLeasesForLandlordProperty_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingPropertyWebApiHandler_getPropertyInfo_Path = '/api/web/v1/property/getPropertyInfo';

/**
 * get property data for listing
 */
export const LeasingPropertyWebApiHandler_getPropertyInfo = (
  getParams: GetPropertyInfoParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPropertyInfoParams, never, GetPropertyInfoResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyWebApiHandler_getPropertyInfo_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingPropertyWebApiHandler_getWebAnalytics_Path = '/api/web/v1/property/getWebAnalytics';

/**
 * get listing web analytics data
 */
export const LeasingPropertyWebApiHandler_getWebAnalytics = (
  getParams: GetWebAnalyticsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetWebAnalyticsParams, never, WebAnalyticsWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyWebApiHandler_getWebAnalytics_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
